import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { AppBar, Toolbar, IconButton, Button, Drawer, useTheme, Box } from "@mui/material";

// @material-ui/icons
import Menu from "@mui/icons-material/Menu";
import Close from "@mui/icons-material/Close";

// core components
import styles from "../../assets/jss/material-kit-pro-react/components/headerStyle.js";
import { getSxStyle } from "../../utils/getSxStyle.js";

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);


  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const headerColorChange = () => {
    //const { color, changeColorOnScroll } = props;

    //const windowsScrollTop = window.pageYOffset;
    // if (windowsScrollTop > changeColorOnScroll.height) {
    //   document.body
    //     .getElementsByTagName("header")[0]
    //     .classList.remove(classes[color]);
    //   document.body
    //     .getElementsByTagName("header")[0]
    //     .classList.add(classes[changeColorOnScroll.color]);
    // } else {
    //   document.body
    //     .getElementsByTagName("header")[0]
    //     .classList.add(classes[color]);
    //   document.body
    //     .getElementsByTagName("header")[0]
    //     .classList.remove(classes[changeColorOnScroll.color]);
    // }
  };

  const { color, links, brand, fixed, absolute } = props;


  return (
    <AppBar sx={{ position: 'absolute', backgroundColor: 'transparent' }}>
      <Toolbar sx={(theme) => getSxStyle(theme, styles, ['container'])}>
        <Button sx={(theme) => getSxStyle(theme, styles, ['title'])} >
          <Link to="/">{brand}</Link>
        </Button>

        <Box
          display={{ xs: "none", sm: "block" }}
          sx={(theme) => getSxStyle(theme, styles, ['hidden'])}
        >
          <Box sx={(theme) => getSxStyle(theme, styles, ['collapse'])}>
            {links}
          </Box>
        </Box>

        <Box display={{ xs: "block", sm: "none" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Box>
      </Toolbar>

      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        sx={(theme) => getSxStyle(theme, styles, ['drawerPaper'])}
        // classes={{
        //   paper: classes.drawerPaper
        // }}
        onClose={handleDrawerToggle}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          sx={(theme) => getSxStyle(theme, styles, ['closeButtonDrawer'])}
        >
          <Close />
        </IconButton>

        <Box
          sx={(theme) => getSxStyle(theme, styles, ['appResponsive'])}
        >
          {links}
        </Box>
      </Drawer>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  links: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};
